import { createSelector } from 'reselect'
import { findBestTransfer } from 'components/Experiences/ExperienceTransfers/ExperienceTransferUtils'
import { getDefaultTransfers, getExperienceOneClickTransferOptions, getOneClickExperienceTransfer } from 'checkout/selectors/experienceSelectors'

const EmptyResult = {
  canUseOneWay: false,
  canUseReturn: false,
  bestToHotelOption: undefined,
  bestToAirportOption: undefined,
}

const getCheckoutLoyaltyEligibleTransferOptions = createSelector(
  (state: App.State) => getOneClickExperienceTransfer(state),
  (state: App.State) => getExperienceOneClickTransferOptions(state),
  (state: App.State) => {
    const transfer = getOneClickExperienceTransfer(state)
    return transfer ? getDefaultTransfers(state, transfer) : undefined
  },
  (oneClickTransfer, oneClickTransferOptions, defaultTransfers) => {
    if (!oneClickTransfer || !defaultTransfers) return EmptyResult

    const { bestTransfer: bestToHotelOption } = findBestTransfer(
      defaultTransfers.toHotel,
      oneClickTransferOptions.toHotelOptions,
    )
    const { bestTransfer: bestToAirportOption } = findBestTransfer(
      defaultTransfers.toAirport,
      oneClickTransferOptions.toAirportOptions.filter(opt => opt.isLoyaltyEligible),
    )

    const canUseOneWay = (bestToHotelOption?.loyaltyOptions?.eligibleTransfer === 'ONE-WAY') ||
      (bestToAirportOption?.loyaltyOptions?.eligibleTransfer === 'ONE-WAY')
    const canUseReturn = (bestToHotelOption?.loyaltyOptions?.eligibleTransfer === 'RETURN') ||
      (bestToAirportOption?.loyaltyOptions?.eligibleTransfer === 'RETURN')

    return { canUseOneWay, canUseReturn, bestToHotelOption, bestToAirportOption }
  },
)

export default getCheckoutLoyaltyEligibleTransferOptions
